import React from "react";
import ModalTitle from 'react-bootstrap/ModalTitle'

function STCModalTitle(props){

    return(
        <ModalTitle
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            as={props.as}
           
        >
            {props.children}
        </ModalTitle>
    )
}
export default STCModalTitle;